'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FormItem;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactackleCore = require('reactackle-core');

var _FormItemStyled = require('./styles/FormItemStyled');

var _theme = require('./styles/theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

(0, _reactackleCore.registerDefaultComponentTheme)('formItem', _theme2.default);

function FormItem(props) {
  return _react2.default.createElement(_FormItemStyled.FormItemStyled, null, props.children);
}

FormItem.displayName = 'FormItem';